// Fix the toggle switch click issue

const ShippingOptions = ({ 
  shippingMethod, 
  setShippingMethod, 
  isFreeShipping, 
  setIsFreeShipping,
  appSettings = { standardShippingCost: 8 } // Default value if not provided
}) => {
  // Helper function to format price
  const formatPrice = (price) => {
    return `${Number(price).toFixed(2)} TND`;
  };

  return (
    <div className="bg-white shadow sm:rounded-lg overflow-hidden">
      <div className="px-6 py-5 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-indigo-100">
        <h3 className="text-lg leading-6 font-medium text-gray-900 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-indigo-600" viewBox="0 0 20 20" fill="currentColor">
            <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
            <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2.05a2.5 2.5 0 014.9 0H19a1 1 0 001-1v-1a1 1 0 00-1-1h-6.5a1 1 0 01-1-1V5a1 1 0 00-1-1H3z" />
          </svg>
          Options de livraison
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Configurez les options de livraison pour cet échange
        </p>
      </div>
      
      <div className="px-6 py-6">
        <div className="space-y-5">
          {/* Standard Shipping Option with Price */}
          <div className={`relative rounded-lg border ${shippingMethod === 'standard' && !isFreeShipping ? 'border-indigo-200 bg-indigo-50' : 'border-gray-200'} p-4 transition-all duration-200 hover:border-indigo-300`}>
            <div className="flex">
              <div className="flex items-center h-5">
                <input
                  id="standard-shipping"
                  name="shipping-method"
                  type="radio"
                  checked={shippingMethod === 'standard'}
                  onChange={() => setShippingMethod('standard')}
                  className="h-5 w-5 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                />
              </div>
              <div className="ml-3 flex justify-between w-full">
                <div>
                  <label htmlFor="standard-shipping" className="font-medium text-gray-900">Livraison standard</label>
                  <p className="text-gray-500 text-sm">
                    Délai de livraison: 3-5 jours ouvrables
                  </p>
                </div>
                <div className="text-right">
                  <span className={`inline-flex items-center font-medium ${isFreeShipping ? 'line-through text-gray-400' : 'text-indigo-700'}`}>
                    {formatPrice(appSettings.standardShippingCost)}
                  </span>
                  {isFreeShipping && (
                    <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Gratuit
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Free Shipping Toggle Option - Fixed version */}
          <div className="relative rounded-lg border border-gray-200 p-4 hover:border-green-300 transition-all duration-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div className="ml-3">
                  <label htmlFor="free-shipping" className="font-medium text-gray-900 cursor-pointer">Livraison gratuite</label>
                  <p className="text-gray-500 text-sm">
                    Offrir la livraison gratuite au client
                  </p>
                </div>
              </div>
              <div 
                className="relative inline-block w-14 align-middle select-none cursor-pointer"
                onClick={() => setIsFreeShipping(!isFreeShipping)}
              >
                <input 
                  type="checkbox" 
                  name="free-shipping" 
                  id="free-shipping" 
                  checked={isFreeShipping}
                  onChange={() => setIsFreeShipping(!isFreeShipping)}
                  className="sr-only"
                />
                <div className="block bg-gray-200 rounded-full h-8 w-14 cursor-pointer"></div>
                <div 
                  className={`absolute left-1 top-1 bg-white rounded-full h-6 w-6 transition-transform duration-200 ease-in-out transform ${
                    isFreeShipping ? 'translate-x-6 bg-green-500' : ''
                  }`}
                ></div>
              </div>
            </div>
          </div>

          {/* Information Card */}
          <div className={`mt-4 p-4 rounded-md border ${isFreeShipping ? 'border-green-200 bg-green-50' : 'border-indigo-200 bg-indigo-50'}`}>
            <div className="flex">
              <div className="flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${isFreeShipping ? 'text-green-600' : 'text-indigo-600'}`} viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className={`text-sm font-medium ${isFreeShipping ? 'text-green-800' : 'text-indigo-800'}`}>
                  {isFreeShipping ? 'Livraison gratuite activée' : 'Frais de livraison standard'}
                </h3>
                <div className="mt-2 text-sm">
                  <p className={isFreeShipping ? 'text-green-700' : 'text-indigo-700'}>
                    {isFreeShipping 
                      ? 'Aucun frais de livraison ne sera facturé au client pour cet échange.'
                      : `Les frais de livraison standard de ${formatPrice(appSettings.standardShippingCost)} seront appliqués à cet échange.`
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingOptions;